import * as React from 'react';

// ##############################
// Icons

export const CopyIcon = (<img src={`./icons/Copy Icon.svg`} />);
export const SecureIcon = (<img src={`./icons/noun_Privacy_3427865 1.svg`} />);
export const ScaleIcon = (<img src={`./icons/noun_Scale_3027192 1.svg`} />);
export const StarIcon = (<img src={`./icons/Star.svg`} />);
export const LightningIcon = (<img src={`./icons/Lightning.svg`} />);
export const CalendarIcon = (<img src={`./icons/Calendar.svg`} />);
export const PopOutIcon = (<img src={`./icons/noun_pop out_1406946 1.svg`} />);
